<template>
  <div class="card card-shadow card-rounded border-0 mb-3">
    <div class="card-body line-height-1">
      <div class="d-flex justify-content-between">
        <div class="text-left">
          <span class="skeleton-item mb-1 small">Longer label text here</span><br>
          <span class="skeleton-item">Button text</span>
        </div>
        <div>
          <div class="skeleton-item rounded-pill" style="min-height: 2rem;"></div>
        </div>
      </div>

      <div class="skeleton-item d-flex my-4" style="min-height: 0.5rem"></div>

      <div class="d-flex justify-content-between">
        <div>
          <span class="skeleton-item mb-1 small">Short label</span><br>
          <span class="skeleton-item">Slightly longer </span>
        </div>
        <div>
          <span class="skeleton-item mb-1 small">Short label</span><br>
          <span class="skeleton-item">Short label</span>
        </div>
        <div class="align-items-center d-flex">
          <div class="skeleton-item rounded-pill" style="width: 1.5rem; height: 1.5rem;"></div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'LoanCardSkeleton'
}
</script>
